import { useContext, useEffect } from "react";
import { DRAFT_ACTIONS } from "../../../components/draft/draftReducer";
import DraftDispatchContext from "../../../contexts/draftDispatchContext";
import useGetter from "../useGetter";
import useQueriesAreLoading from "../useQueriesAreLoading";
import useDraftId from "./useDraftId";
import useDraftSettings from "./useDraftSettings";

export default function useDraftPicks() {
  const { draftSettingsData, draftSettingsQuery } = useDraftSettings();
  const draftId = useDraftId();
  const draftDispatch = useContext(DraftDispatchContext);

  const { data: draftPicksData, query: draftPicksQuery } = useGetter(
    `/drafts/${draftId}/picks`,
    { enabled: !!draftId }
  );

  const isLoading =
    useQueriesAreLoading([draftSettingsQuery, draftPicksQuery]) ||
    !(draftSettingsData && draftPicksData);

  let hasFirstPickBeenMade = false;
  let hasLastPickBeenMade = false;

  let pickNumOnClock = null;
  let teamIdOnClock = null;
  let teamIdUpNext = null;
  let spots = null;
  let spotsAsString = null;

  if (!isLoading) {
    hasFirstPickBeenMade = !!draftPicksData.picks[0].player;

    const numPicks = draftPicksData.picks.length;
    const lastPick = draftPicksData.picks[numPicks - 1];
    hasLastPickBeenMade = !!lastPick.player;
    for (let p = 0; p < numPicks; p++) {
      const pick = draftPicksData.picks[p];
      if (!pick.player) {
        pickNumOnClock = pick.pickNum;
        teamIdOnClock = pick.team;
        break;
      }
    }

    if (pickNumOnClock && pickNumOnClock < numPicks)
      teamIdUpNext = draftPicksData.picks[pickNumOnClock].team;

    spots = [];
    for (let i = 0; i < draftSettingsData.settings.numTeams; i++) {
      spots.push(draftPicksData.picks[i].team);
    }
    spotsAsString = spots.join(",");
  }

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: {
        propName: "hasFirstPickBeenMade",
        value: hasFirstPickBeenMade,
      },
    });
  }, [hasFirstPickBeenMade, draftDispatch]);

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: {
        propName: "hasLastPickBeenMade",
        value: hasLastPickBeenMade,
      },
    });
  }, [hasLastPickBeenMade, draftDispatch]);

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: {
        propName: "pickNumOnClock",
        value: pickNumOnClock,
      },
    });
  }, [pickNumOnClock, draftDispatch]);

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: {
        propName: "teamIdOnClock",
        value: teamIdOnClock,
      },
    });
  }, [teamIdOnClock, draftDispatch]);

  useEffect(() => {
    if (teamIdUpNext)
      draftDispatch({
        type: DRAFT_ACTIONS.SET_INFO,
        payload: {
          propName: "teamIdUpNext",
          value: teamIdUpNext,
        },
      });
  }, [teamIdUpNext, draftDispatch]);

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_SPOTS,
      payload: spotsAsString,
    });
  }, [spotsAsString, draftDispatch]);

  return { draftPicksData, draftPicksQuery };
}
